import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { PHONE_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const PhoneRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={PHONE_ROUNDED_GLYPH} />;
